import React, { useEffect, useState } from "react";
import logo from "./logo.png";
import "./App.css";
import { styled } from "@mui/material/styles";
import skip from "./skip.png";
import { Button, responsiveFontSizes, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Option from "./components/Options";
import RadionButton from "./components/RadioButton";
// const bg = require("./bg.jpeg");
const skipcashBlue = "#1e3f91";

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(skipcashBlue),
  backgroundColor: skipcashBlue,
  color: "white",
  textTransform: "capitalize",
  fontFamily: "Nunito",

  "&:hover": {
    backgroundColor: "white",
    borderColor: skipcashBlue,
    borderWidth: 1,
    borderStyle: "solid",
    color: skipcashBlue,
    textTransform: "capitalize",
    fontFamily: "Nunito",
  },
}));

function App() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [name, setName] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [qid, setQid] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
    const [workplace, setWorkPlace] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
    const [jobtitle, setJobTitle] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [option, setOption] = useState({ value: "", err: false, errTxt: "" });
  const [phone, setPhone] = useState({ value: "", err: false, errTxt: "" });
  const [email, setEmail] = useState({ value: "", err: false, errTxt: "" });
  const [amount, setAmount] = useState({ value: "", err: false, errTxt: "" });
  const [CurrentNumber, setCurrentNumber] = useState(0);
  // const options = [
  //   "6 Months Unlimited - Before: 5400, QAR After: 3780 QAR",
  //   "12 Months Unlimited - Before: 9600, QAR After: 5760 QAR",
  //   "50 Sessions - Before: 3250 QAR, After: 2275 QAR",
  // ];

  const [clicked, setClicked] = useState(false);

  const [totalAmount, setTotalAmount] = useState(150);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  const getCurrentNumber = async () => {
    
    const response = await fetch(
      "https://qatarse-85ab0bea6b65.herokuapp.com/getCount",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const json = await response.json();
    console.log("json : ", json.currentNumber);
    if (json.error) {
      alert(json.message);
      return;
    } else {
      setCurrentNumber(json.currentNumber);
    }
    console.log("count is : ",CurrentNumber)
  };

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
     getCurrentNumber();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleData = (value, field, index) => {
    if (field === "name") setName({ value, err: false, errTxt: "" });
    else if (field === "qid") setQid({ value, err: false, errTxt: "" });
    else if (field === "jobtitle") setJobTitle({ value, err: false, errTxt: "" });
    else if (field === "workplace") setWorkPlace({ value, err: false, errTxt: "" });
    else if (field === "phone") setPhone({ value, err: false, errTxt: "" });
    else if (field === "email") setEmail({ value, err: false, errTxt: "" });
    else if (field === "amount") {
      setAmount({ value, err: false, errTxt: "" });
      setTotalAmount(value);
    } else console.log("All good");
  };

  const pay = async () => {
    console.log("inside pay")
    setClicked(true);
    const nameRegEx = /^[A-Za-z ]+$/;
    const numRegEx = new RegExp("^[0-9]*$");
    if (name.value === "") {
      setName({
        value: "",
        err: true,
        errTxt: " Name cannot be empty",
      });
      setClicked(false);

      return;
    }
    if (!nameRegEx.test(name.value)) {
      setName({
        value: "",
        err: true,
        errTxt: " Name can only have English Letters",
      });
      setClicked(false);
      return;
    }
    if (qid.value === "") {
      setQid({
        value: "",
        err: true,
        errTxt: "QID cannot be empty",
      });
      setClicked(false);
      return;
    }
     if (phone.value === "") {
      setPhone({
        value: "",
        err: true,
        errTxt: "Phone Number cannot be empty",
      });
      setClicked(false);
      return;
    }
    if (!numRegEx.test(phone.value)) {
      setPhone({
        value: "",
        err: true,
        errTxt: "Invalid Phone Number",
      });
      setClicked(false);
      return;
    }
    if (email.value === "") {
      setEmail({
        value: "",
        err: true,
        errTxt: "Email cannot be empty",
      });
      setClicked(false);
      return;
    }
     if (workplace.value === "") {
      setWorkPlace({
        value: "",
        err: true,
        errTxt: "Work Place cannot be empty",
      });
      setClicked(false);
      return;
    }
    if (jobtitle.value === "") {
      setJobTitle({
        value: "",
        err: true,
        errTxt: "Job Title cannot be empty",
      });
      setClicked(false);
      return;
    }
   
    // if (amount.value === "") {
    //   setAmount({
    //     value: "",
    //     err: true,
    //     errTxt: "Amount cannot be empty",
    //   });
    //   setClicked(false);
    //   return;
    // }
    // alert(amount.value);

    // if (recieve === "") {
    //   alert("Missing or Invalid Details");
    //   setClicked(false);

    //   return;
    // }
    if (totalAmount > 60000) {
      alert("Total Amount Should Be Less than 60000");
      setClicked(false);

      return;
    }

    const url = "https://qatarse-85ab0bea6b65.herokuapp.com/pay";
    //const url = "http://localhost:4000/pay";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name.value,
        phoneNumber: phone.value,
        email: email.value,
        amount: totalAmount,
        Description: `ID: ${qid.value}, WorkPlace: ${workplace.value}, Title: ${jobtitle.value}`
      }),
    });
    const json = await response.json();

    window.location = json.payUrl;
  };

  // useEffect(() => {
  //   calculateTotal();
  // }, [flag]);

  // const calculateTotal = () => {
  //   let total = 0;
  //   setCalculated(true);
  //   if (delivery) total = total + 40;
  //   setTotalAmount(total);
  // };

  const styles = {
    container: {
      //backgroundColor: "#242424",
      width: "100%",
      //height: "auto",
      margin: 0,
      display: "flex",
      overflow: "hidden",
      flex: 1,
      flexDirection: "column",
      //minHeight: "100%",
    },
    whiteContainer: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "5%",
      paddingBottom: "5%",
      // height: "100%",sz
      height: "auto",
    },
    mobileButton: {
      width: "100%",
      padding: "5%",
      borderRadius: 10,
      fontStyle: "Quicksand",
      fontSize: "1em",
      height: 40,
    },
    desktopButton: {
      width: "100%",
      padding: "2%",
      borderRadius: 10,
      fontStyle: "Quicksand",
      fontSize: "1.2em",
      height: 20,
    },
    fontSizeStyle: {
      fontFamily: "Quicksand",
      fontSize:
        windowDimensions.width <= 380
          ? "0.75em"
          : windowDimensions.width <= 500
          ? "0.8em"
          : windowDimensions.width > 500 && windowDimensions.width < 600
          ? "1em"
          : windowDimensions.width >= 600 && windowDimensions.width < 1000
          ? "1em"
          : windowDimensions.width < 1500
          ? "1em"
          : "1em",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.whiteContainer}>
        <div
          style={{
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "transparent",
            borderRadius: 10,
            width: "90%",
            background: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={logo} style={{ height: windowDimensions.height / 4 }} />
          </div>
          {CurrentNumber < 200 ? (
            <div>
              <div
                style={{
                  fontFamily: "Poppins",
                  marginLeft: "5%",
                  marginRight: "5%",
                }}
              >

                
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h3 style={styles.fontSizeStyle}>{`Full Name:`}</h3>
                  <h3 style={styles.fontSizeStyle}>{`:الاسم الكامل`}</h3>
                </div>
                <div
                  style={{
                    marginTop: "1%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    fullWidth
                    //label="Full Name - الاسم الكامل"
                    id="fullWidth"
                    onChange={(e) => handleData(e.target.value, "name")}
                    error={name.err}
                    helperText={name.errTxt}
                    type="text"
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h3 style={styles.fontSizeStyle}>{`QID:`}</h3>
                  <h3 style={styles.fontSizeStyle}>{`:الرقم الشخصي`}</h3>
                </div>
                <div
                  style={{
                    marginTop: "1%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    fullWidth
                    //label="Full Name - الاسم الكامل"
                    id="fullWidth"
                    onChange={(e) => handleData(e.target.value, "qid")}
                    error={qid.err}
                    helperText={qid.errTxt}
                    type="text"
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h3 style={styles.fontSizeStyle}>{`Phone Number:`}</h3>
                  <h3 style={styles.fontSizeStyle}>{`:رقم الجوال`}</h3>
                </div>
                <div
                  style={{
                    marginTop: "1%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    fullWidth
                    //label="Phone Number - رقم الجوال"
                    id="fullWidth"
                    onChange={(e) => handleData(e.target.value, "phone")}
                    error={phone.err}
                    helperText={phone.errTxt}
                    type="number"
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h3 style={styles.fontSizeStyle}>{`Email Address:`}</h3>
                  <h3 style={styles.fontSizeStyle}>{`:البريد الالكتروني`}</h3>
                </div>
                <div
                  style={{
                    marginTop: "1%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    fullWidth
                    // label="Email Address - البريد الالكتروني"
                    id="fullWidth"
                    onChange={(e) => handleData(e.target.value, "email")}
                    error={email.err}
                    helperText={email.errTxt}
                    type="email"
                  />
                </div>
                   <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h3 style={styles.fontSizeStyle}>{`Place Of Work:`}</h3>
                  <h3 style={styles.fontSizeStyle}>{`:جهة العمل`}</h3>
                </div>
                <div
                  style={{
                    marginTop: "1%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    fullWidth
                    // label="Email Address - البريد الالكتروني"
                    id="fullWidth"
                    onChange={(e) => handleData(e.target.value, "workplace")}
                    error={workplace.err}
                    helperText={workplace.errTxt}
                    type="text"
                  />
                </div>
                   <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h3 style={styles.fontSizeStyle}>{`Job Title:`}</h3>
                  <h3 style={styles.fontSizeStyle}>{`:المسمى الوظيفي`}</h3>
                </div>
                <div
                  style={{
                    marginTop: "1%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    fullWidth
                    // label="Email Address - البريد الالكتروني"
                    id="fullWidth"
                    onChange={(e) => handleData(e.target.value, "jobtitle")}
                    error={jobtitle.err}
                    helperText={jobtitle.errTxt}
                    type="text"
                  />
                </div>
                {/* <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h3 style={styles.fontSizeStyle}>{`Amount:`}</h3>
                  <h3 style={styles.fontSizeStyle}>{`: المبلغ`}</h3>
                </div>
                <div
                  style={{
                    marginTop: "1%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    fullWidth
                    // label="Email Address - البريد الالكتروني"
                    id="fullWidth"
                    onChange={(e) => handleData(e.target.value, "amount")}
                    error={amount.err}
                    helperText={amount.errTxt}
                    type="number"
                  />
                </div> */}

                {/* New code */}

                {/* <h5>Would you like to :</h5>
            <RadionButton dcategory={dcategory} handleChange={handleChange} />
            {showNote && (
              <h6 style={{ color: "red" }}>
                Note: Please collect it from the studio
              </h6>
            )} */}
                <div
                  style={{
                    marginTop: "1.5%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h3
                    style={{
                      fontFamily: "Nunito",
                      fontSize: "1.1em",
                      opacity: 0.3,
                    }}
                  >
                    Total
                  </h3>
                  <h3
                    style={{
                      fontFamily: "Nunito",
                      fontSize: "1.1em",
                      // opacity: 0.3,
                    }}
                  >
                    {`${totalAmount} QAR`}
                  </h3>
                </div>
              </div>

              <div
                style={{
                  // height: windowDimensions.height / 3,
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "90%", padding: "2%" }}>
                  {clicked ? (
                    <LoadingButton
                      loading
                      variant="outlined"
                      style={
                        windowDimensions.width < 1000
                          ? styles.mobileButton
                          : styles.desktopButton
                      }
                    >
                      SUBMIT
                    </LoadingButton>
                  ) : (
                    <ColorButton
                      onClick={() => pay()}
                      style={
                        windowDimensions.width < 1000
                          ? styles.mobileButton
                          : styles.desktopButton
                      }
                    >
                      Proceed to Pay
                    </ColorButton>
                  )}
                </div>

                {/* <h1>hello</h1> */}
              </div>
              <div
                style={{
                  // padding: "5%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                }}
              >
                <img
                  src={skip}
                  style={
                    windowDimensions.width < 1000
                      ? { height: windowDimensions.width / 8 }
                      : { height: windowDimensions.width / 25 }
                  }
                />
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "Nunito",
              }}
            >
              {/* <h3>EVENT IS FULLY BOOKED</h3> */}
              <h3>NOT AVAILABLE</h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
